"use client";

import { useState } from "react";
import Image from "next/image";
import EquipmentDialog, { EquipmentItem } from "./EquipmentDialog";

const CATEGORIES = [
  { label: "Sve (14)", value: "sve" },
  { label: "Sprave (14)", value: "Sprave" },
];

const ITEMS: EquipmentItem[] = [
  {
    id: "1",
    name: "Nautilus Pullover",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/Nautilus-Inspiration-Pull-Over.webp",
    description:
      "Klasična sprava za izolirano jačanje širokog leđnog mišića i stabilizatora ramena kroz pokret povlačenja iznad glave. Prepoznatljiva Nautilus krivulja opterećenja prati prirodnu snagu mišića kroz cijeli raspon pokreta.",
  },
  {
    id: "2",
    name: "Iso-Lateral Leg Press",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/Iso-Lateral_Leg_Press.webp",
    description:
      "Sprava za potisak nogu s neovisnim pokretom svake strane, što omogućuje ravnomjeran razvoj snage i ispravlja asimetrije. Pogodna za jačanje kvadricepsa, stražnjice i zadnje lože natkoljenice.",
  },
  {
    id: "3",
    name: "Smith Mašina",
    tags: ["Cijelo tijelo"],
    category: "Sprave",
    image: "/img/equipment/smith_machine.webp",
    description:
      "Univerzalna sprava s vođenom okomitom putanjom šipke koja omogućuje sigurno izvođenje čučnjeva, potisaka i drugih osnovnih vježbi bez potrebe za asistencijom. Idealna za početnike i naprednije korisnike.",
  },
  {
    id: "4",
    name: "Stair master",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/stairmaster.jfif",
    description:
      "Kardio sprava koja simulira penjanje stubama, izvrsna za jačanje nogu i stražnjice uz visoku potrošnju kalorija. Podesivi intenzitet omogućuje trening prilagođen svim razinama kondicije.",
  },
  {
    id: "5",
    name: "Hammer Hack Squat",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-hack-squat.webp",
    description:
      "Sprava za čučnjeve s nagnutom, vođenom putanjom koja rasterećuje donji dio leđa uz snažnu aktivaciju kvadricepsa. Sigurnosni osloni omogućuju rad s velikim opterećenjima bez asistencije.",
  },
  {
    id: "6",
    name: "Hammer Incline Chest Press",
    tags: ["Gronji dio prsa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-incline-press.webp",
    description:
      "Iso-lateralna sprava za potisak pod kutom namijenjena razvoju gornjeg dijela prsnih mišića i prednjih ramena. Neovisan pokret svake ruke poboljšava simetriju i kontrolu tijekom vježbe.",
  },
  {
    id: "7",
    name: "Hammer Chest Press",
    tags: ["Srednji dio prsa"],
    category: "Sprave",
    image: "/img/equipment/Hammer_Strength_Chest_press.webp",
    description:
      "Iso-lateralna sprava za razvoj prsnih mišića koja omogućuje neovisan pokret svake ruke, čime se poboljšava simetrija i aktivacija mišića. Idealna za progresivno opterećenje kroz sigurnu, kontroliranu putanju pokreta.",
  },
  {
    id: "8",
    name: "Hammer Wide Chest Press",
    tags: ["Vanjski dio prsa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-iso-lateral-wide-chest.webp",
    description:
      "Sprava sa širim hvatom namijenjena naglašenoj aktivaciji vanjskog dijela prsnih mišića. Iso-lateralni dizajn omogućuje prirodniju putanju pokreta i bolju kontrolu opterećenja.",
  },
  {
    id: "9",
    name: "Hammer Iso-Lateral Row",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-later-rowing-machine.webp",
    description:
      "Sprava za veslanje s neovisnim pokretom svake ruke, namijenjena jačanju širine i debljine leđnih mišića. Opterećenje pločicama omogućuje postupno povećanje intenziteta treninga.",
  },
  {
    id: "10",
    name: "Booty Builder / Back Extension",
    tags: ["Gluteus", "Donja leđa"],
    category: "Sprave",
    image: "/img/equipment/BB_Backextension.webp",
    description:
      "Sprava specijalizirana za jačanje gluteusa kroz pokret ekstenzije kuka, uz mogućnost izvođenja i ekstenzije leđa. Podesivo opterećenje i udoban jastuk omogućuju siguran trening za sve razine iskustva.",
  },
  {
    id: "11",
    name: "Technogym Iso-Lateral High Row",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/Iso-Lat-High-Row.webp",
    description:
      "Sprava za povlačenje iz visokog položaja koja cilja gornji dio leđa i stražnje ramene mišiće. Neovisan pokret svake ruke osigurava ravnomjeran razvoj snage s obje strane tijela.",
  },
  {
    id: "12",
    name: "Hip Thrust (Smith Machine)",
    tags: ["Gluteus"],
    category: "Sprave",
    image: "/img/equipment/hip-thrust-machine-with-smith.webp",
    description:
      "Prilagodba Smith mašine namijenjena izvođenju hip thrust pokreta uz vođenu, sigurnu putanju šipke. Izvrsna za ciljano jačanje gluteusa uz mogućnost progresivnog povećanja opterećenja.",
  },
  {
    id: "13",
    name: "Hammer Plate Load Shoulder Press ISO",
    tags: ["Ramena"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-lateral-shoulder-press.webp",
    description:
      "Iso-lateralna sprava za potisak iznad glave namijenjena jačanju ramena uz kontroliranu, sigurnu putanju pokreta. Neovisan rad svake ruke pomaže u ispravljanju asimetrija u snazi.",
  },
  {
    id: "14",
    name: "PULL/PUSH saonice",
    tags: ["Cijelo tijelo", "Kardio"],
    category: "Sprave",
    image: "/img/equipment/Prowler-Sled-Push-Pull-per-Allen.webp",
    description:
      "Saonice za guranje i povlačenje namijenjene funkcionalnom treningu snage i kondicije cijelog tijela. Svestran alat za razvoj eksplozivnosti, izdržljivosti i snage nogu bez opterećenja zglobova udarcima.",
  },
];

export default function EquipmentGridSection() {
  const [activeCategory, setActiveCategory] = useState("sve");
  const [selectedItem, setSelectedItem] = useState<EquipmentItem | null>(null);

  const filtered =
    activeCategory === "sve"
      ? ITEMS
      : ITEMS.filter((item) => item.category === activeCategory);

  return (
    <section className="pb-20 pt-4">
      {/* Filter pills */}
      <div className="mb-8 flex flex-wrap gap-2">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.value}
            onClick={() => setActiveCategory(cat.value)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              activeCategory === cat.value
                ? "bg-[#18181b] text-white"
                : "bg-[#F4F4F5] text-[#18181b] hover:bg-[#E4E4E7]"
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((item) => (
          <button
            key={item.id}
            onClick={() => setSelectedItem(item)}
            className="group flex flex-col overflow-hidden rounded-2xl border border-[#E4E4E7] text-left transition-shadow hover:shadow-md"
          >
            {/* Image area */}
            <div className="relative h-52 w-full bg-white">
              <Image
                src={item.image}
                alt={item.name}
                fill
                className="object-contain p-4 transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Content area */}
            <div className="flex-1 bg-[#F9FAFB] px-4 pb-5 pt-4">
              <p className="mb-2 text-lg font-bold text-[#18181b]">{item.name}</p>
              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-[#E4E4E7] bg-white px-2.5 py-0.5 text-xs font-medium text-[#18181b]"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Dialog */}
      <EquipmentDialog item={selectedItem} onClose={() => setSelectedItem(null)} />
    </section>
  );
}
